import http from "../../utils/http";

export const addMembership = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/membership`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getMemberships = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/membership/list`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const deleteMemberships = (data) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/membership`, { data })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const editMembership = (idx, params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/membership/${idx}`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const membershipAllDisabled = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/membership/all/disabled`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getMembershipHistories = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/membership/history/list`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getMembershipHistoryDetails = (companyIdx, params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/membership/history/${companyIdx}/details`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getMembershipEnableHistory = (companyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/membership/history/${companyIdx}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const editMembershipEnableHistory = (idx, params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/membership/history/${idx}`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const editMembershipEnableHistoryList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/membership/history/change/list`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getMembershipDetails = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/membership/detail/list`, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};